import { render, staticRenderFns } from "./DatosPedidoComponent.vue?vue&type=template&id=16781e89&scoped=true"
import script from "./DatosPedidoComponent.vue?vue&type=script&lang=js"
export * from "./DatosPedidoComponent.vue?vue&type=script&lang=js"
import style0 from "./DatosPedidoComponent.vue?vue&type=style&index=0&id=16781e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16781e89",
  null
  
)

export default component.exports